import clsx from "clsx";
import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import { buyNowContext } from "../BuyNow";
import trackingScripts from "../../utils/trackingScripts";
import { createPlanObject, FACEBOOK_EVENTS } from "../../utils/facebookHelper";
import ProductPrice from "../common/ProductPrice";
import { useViewport } from "../../utils/custom_hooks";
import {PLAN_NAMES} from "../../../../constants";

const PlanChoice = (props) => {
  const { isProduction, promotional } = useContext(buyNowContext);
  const fbTrackingPlanObject = createPlanObject(props.plan);
  const { isSMView } = useViewport();

  const immediatePlan = () => {
    return (
      <div className="row">
        <div className="col-10 text-start d-flex align-items-center">
          <h3 className="d-inline pe-2 fw-bold plan-price-txt h-auto">{props.plan.displayName}</h3>

          {
            props.plan.name === PLAN_NAMES.YEARLY &&
            <p className="rounded teal d-inline px-1 ms-sm-3 ms-lg-0 offer-text">SAVE 20%</p>
          }

          {
            props.plan.name === PLAN_NAMES.THREE_YEAR &&
            <p className="rounded teal d-inline px-1 ms-sm-3 ms-lg-0 offer-text">SAVE 30%</p>
          }
        </div>

        <div className="col-2 d-flex justify-content-end ps-0 ps-sm-2">
          <h3 className="text-end fw-bold plan-price-txt">$<ProductPrice hideDecimalIfWhole={true} priceOverride={props.plan.displayPrice || props.plan.price} /></h3>
        </div>

        {
          props.plan.tagLine1 &&
          <h3 className="col-10 text-start sub-txt">{props.plan.tagLine1}</h3>
        }

        {
          props.plan.tagLine2 &&
          <h3 className="col-10 text-start sub-txt font-italic" style={{ lineHeight: "30px", color: "red" }}>{props.plan.tagLine2}</h3>
        }

        {props.plan.centerBanner &&
          <div className="d-flex align-items-center plan-center-banner">
            <div className="flex-grow-1 content">
              {props.plan.centerBanner}
            </div>
          </div>
        }
      </div>
    )
  };

  // Displays a "delayed monthly" plan with a focus on the effective monthly price.
  const delayedMonthlyPlanMonthlyFocus = () => {
    return (
      <div className="d-flex">
        <div className="d-flex flex-column align-items-start flex-grow-1 justify-content-center">
          <h3 className="d-inline pe-2 fw-bold plan-price-txt h-auto">{props.plan.displayName}</h3>

          {
            props.plan.tagLine1 &&
            <h3 className="text-start plan-sub-txt">{props.plan.tagLine1}</h3>
          }

          {
            props.plan.tagLine2 &&
            <h3 className="text-start plan-sub-txt font-italic pb-0" style={{ lineHeight: "30px", color: "red" }}>{props.plan.tagLine2}</h3>
          }
        </div>


        <div className="d-flex flex-column justify-content-center align-items-end flex-grow-1">
          <p className="sub-txt pb-0">Amounts to</p>

          <h3 className="text-end fw-bold plan-price-txt" style={{ fontSize: "32px" }}>
            $<ProductPrice hideDecimalIfWhole={true} priceOverride={props.plan.displayPrice || props.plan.price}/>
          </h3>

          <p className="sub-txt pb-0">per month</p>
        </div>

        {props.plan.centerBanner &&
        <div className="d-flex align-items-center plan-center-banner">
          <div className="flex-grow-1 content">
            {props.plan.centerBanner}
          </div>
        </div>
        }

      </div>
    );
  };

  // Displays a "delayed monthly" plan with a focus on the total price of the initial membership.
  const delayedMonthlyPlanTotalFocus = () => {
    const discountedPromoPrice = props.plan.promotionalEnabledForPlan && promotional.promoCode.promoType === "f" ? props.plan.price - promotional.promoCode.amount : null;

    return (
      <div className="d-flex">
        <div className="d-flex">
          <div className="d-flex flex-column align-items-start justify-content-center">
            <h3 className="d-inline pe-2 fw-bold plan-price-txt h-auto">{props.plan.displayName}</h3>
            {
              props.plan.tagLine1 &&
              <h3 className="text-start plan-sub-txt">{props.plan.tagLine1Monthly}</h3>
            }
          </div>

          {/* Show a promo icon if the plan is covered by the promo as long as we have enough room to display the icon. */}
          {props.plan.promotionalEnabledForPlan && promotional.planIconImage && !isSMView &&
            <img
              id="buy-now-promo-banner-desktop"
              className="img-fluid w-25 ms-2"
              style={{ zIndex: 1 }}
              src={promotional.planIconImage}
              alt='fall-sale-banner'
            />
          }
        </div>

        {/* Show the discounted promo price if applicable. */}
        {discountedPromoPrice &&
          <div className="d-flex flex-column justify-content-center align-items-end flex-grow-1 ms-2">
            <h3 className="text-end fw-bold" style={{ fontSize: "32px" }}>
              $<ProductPrice hideDecimalIfWhole={true} product={props.plan} priceOverride={discountedPromoPrice} />
            </h3>
          </div>
        }

        {/* If there is a discounted promo price, we'll display the original plan price with strikethrough text. */}
        <div className={clsx("d-flex flex-column justify-content-center align-items-end ms-2", discountedPromoPrice ? "" : "flex-grow-1")} >
          <h3 className={clsx("text-end fw-bold", discountedPromoPrice ? "text-decoration-line-through text-danger" : "" )} style={{ fontSize: "32px" }}>
            $<ProductPrice hideDecimalIfWhole={true} product={props.plan} />
          </h3>
        </div>

        {props.plan.centerBanner &&
          <div className="d-flex align-items-center plan-center-banner">
            <div className="flex-grow-1 content">
              {props.plan.centerBanner}
            </div>
          </div>
        }
      </div>
    );
  };

  // We have slightly different formatting for different types of plans.
  const buttonContent = props.plan.isDelayedMonthlyPlan ? delayedMonthlyPlanTotalFocus() : immediatePlan();

  return (
    <button
      className={`col-lg-12 btn plan-container my-3 ` + (props.isClicked ? 'selected' : '')}
      onClick={() => {
        props.onSelected(props.plan)
        trackingScripts.facebook(isProduction, FACEBOOK_EVENTS.VIEW_CONTENT_PLAN, fbTrackingPlanObject, "trackCustom");
      }}
    >
      {buttonContent}
    </button>
  );
};

PlanChoice.defaultProps = {
  isClicked: false
};

PlanChoice.propTypes = {
  plan: PropTypes.object.isRequired,
  onSelected: PropTypes.func.isRequired,
  isClicked: PropTypes.bool
};

export default PlanChoice;